import QuantityUnit from '../enums/QuantityUnit';

export default function quantityUnit(unit: string): string {

    switch(unit) {

        case QuantityUnit.BRUTO: return 'Bruto';
        case QuantityUnit.NETTO: return 'Netto';
        default: return '';
    }
}
